var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{attrs:{"id":"demo"}},[_c('item',{staticClass:"item",attrs:{"model":_vm.treeData}}),_vm._v(" "),_c('p',[_vm._v("您好，仅供个人测试，无真实内容，勿随意传播")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/.13.0.5@vue-loader/lib/template-compiler?{"id":"data-v-52965a18","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.13.0.5@vue-loader/lib/selector.js?type=template&index=0!./src/views/Index.vue
// module id = jhMc
// module chunks = 0